<template>
    <console-layout width="100%" max-width="600">

        <console-title>
            <span v-if="$route.params._viewer">뷰어 상세</span>
            <span v-else>뷰어 생성</span>
        </console-title>

        <console-body>
            <v-card>
                <v-card-title class="subtitle-2">기본정보</v-card-title>
                <v-card-text>
                    <v-text-field v-model="viewer.username" label="아이디" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-password-field v-model="viewer.password" label="비밀번호" persistent-placeholder hide-details class="mt-4"></v-password-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="viewer.name" label="담당자(이름)" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="viewer.phone" label="담당자(연락처)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="viewer.email" label="담당자(이메일)" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="viewer.postcode" label="우편번호" persistent-placeholder hide-details></v-text-field>
                    <v-text-field v-model="viewer.address1" label="기본주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                    <v-text-field v-model="viewer.address2" label="상세주소" persistent-placeholder hide-details class="mt-4"></v-text-field>
                </v-card-text>
                <v-divider />
                <v-card-text>
                    <v-text-field v-model="viewer.ci" label="ci" persistent-placeholder hide-details></v-text-field>
                </v-card-text>
                <v-card-actions />
            </v-card>
        </console-body>

        <v-row class="my-4">
            <v-spacer/>
            <v-col cols="auto">
                <v-btn color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

    </console-layout>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        VPasswordField
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            viewer: {
                username: null,
                password: null,
                name: null,
                phone: null,
                email: null,
                postcode: null,
                address1: null,
                address2: null,
            }
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            if(this.$route.params._id){
                let { viewer } = await api.console.user.viewers.get({ _id: this.$route.params._id });
                this.viewer = {
                    ...this.viewer,
                    ...viewer
                };
            }
        },

        async save(){
            this.viewer._id
            ? await api.console.user.viewers.put({
                ...this.viewer,
                password: this.viewer.password ? CryptoAES.encrypt(this.viewer.password) : undefined
            })
            : await api.console.user.viewers.post({
                ...this.viewer,
                password: this.viewer.password ? CryptoAES.encrypt(this.viewer.password) : undefined
            });

            alert("저장되었습니다");
            this.$router.push(`/console/user/viewers`);
        }
    }
}
</script>